var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_2651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24742 0C3.69347 0 0 3.582 0 8C0 11.5347 2.36289 14.5333 5.64055 15.5913C6.05223 15.6653 6.18557 15.4173 6.18557 15.2067V13.7173C3.89141 14.2013 3.41375 12.7733 3.41375 12.7733C3.03849 11.8487 2.49759 11.6027 2.49759 11.6027C1.74914 11.106 2.55464 11.1167 2.55464 11.1167C3.38282 11.1727 3.81856 11.9413 3.81856 11.9413C4.55395 13.164 5.74777 12.8107 6.21856 12.606C6.2921 12.0893 6.50584 11.736 6.74227 11.5367C4.91065 11.3333 2.98488 10.6473 2.98488 7.58267C2.98488 6.70867 3.30722 5.99533 3.83436 5.43533C3.74914 5.23333 3.46667 4.41933 3.91478 3.318C3.91478 3.318 4.60756 3.10333 6.1835 4.138C6.84124 3.96067 7.54639 3.872 8.24742 3.86867C8.94845 3.872 9.65429 3.96067 10.3134 4.138C11.888 3.10333 12.5794 3.318 12.5794 3.318C13.0282 4.42 12.7457 5.234 12.6605 5.43533C13.1897 5.99533 13.5093 6.70933 13.5093 7.58267C13.5093 10.6553 11.5801 11.332 9.74364 11.53C10.0392 11.778 10.3093 12.2647 10.3093 13.0113V15.2067C10.3093 15.4193 10.4412 15.6693 10.8598 15.5907C14.1347 14.5313 16.4948 11.5333 16.4948 8C16.4948 3.582 12.8021 0 8.24742 0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_2651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4948,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.cbe579e6b5ffd2628a744f9ce1edafd4.svg";
export { ForwardRef as ReactComponent };